// extracted by mini-css-extract-plugin
export default {"header":"FooterMarks_header__62fXO","text":"FooterMarks_text__S0w9O","mark":"FooterMarks_mark__yI703","marks_container":"FooterMarks_marks_container__V5wp0"};